
import logInternalLinkClick from "lib/ga/internalLinkClick";
import { useState } from "react";
import styles from './sponsoredPill.module.css';
import globalStyles from '../result.module.css';
interface Props {
    sponsored: boolean,
    type?: string,
    companyName: string,
    id: number
}

const SponsoredPill = ({ sponsored, type, companyName, id }: Props) => {

    const [isHover, setIsHover] = useState(false);

    let sponsoredtext = companyName ? `This scheme has been sponsored by ${companyName}. To find out the benefits of Scheme Sponsorship click here.` : `This scheme has been sponsored. To find out the benefits of Scheme Sponsorship click here.`;

    return <div className={styles.PillContainer}>
        <a href="/landlord-pricing">
            <div className={styles.pill} onMouseEnter={() => {
                setIsHover(true)
            }}
                onMouseLeave={() => {
                    setIsHover(false)
                }}
                onClick={(e) => logInternalLinkClick("Scheme sponsored pill", "/landlord-pricing", id)}>
                <div className={`${globalStyles.boldText} ${globalStyles.mediumText}`} >{sponsored ? 'Featured' : 'Unsponsored'}</div>
            </div>
        </a>
        {isHover && <div className={styles.messageContainer}><div className={`${globalStyles.boldText} ${globalStyles.smallText}`} >
            {sponsoredtext}
        </div>
        </div>}
    </div>
};

export default SponsoredPill;
